/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LookupInternalResponseListBaseResponse as ModelsV3CommonLookupInternalResponseListBaseResponse } from '../../models/Models/v3/Common/lookup-internal-response-list-base-response';

export interface V3PublicApplicationLookupsApplicationIdCountriesGet$Plain$Params {
  applicationId: string;
}

export function v3PublicApplicationLookupsApplicationIdCountriesGet$Plain(http: HttpClient, rootUrl: string, params: V3PublicApplicationLookupsApplicationIdCountriesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3CommonLookupInternalResponseListBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v3PublicApplicationLookupsApplicationIdCountriesGet$Plain.PATH, 'get');
  if (params) {
    rb.path('applicationId', params.applicationId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV3CommonLookupInternalResponseListBaseResponse>;
    })
  );
}

v3PublicApplicationLookupsApplicationIdCountriesGet$Plain.PATH = '/v3/public/application/lookups/{applicationId}/countries';
